var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _g2, _path62, _path63, _path64, _g3, _g4, _g5, _g6, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 338,
    viewBox: "0 0 378 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M177.183 61.0913L177.149 75.6539L128 45.0993L128.033 30.5367L177.183 61.0913Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226 30.5367L177.183 61.0913L128.033 30.5367L176.867 0L226 30.5367Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130 31.4866L129.967 46.0492L81.1493 76.6038L81.1825 62.0412L130 31.4866Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M81.1826 62.0412L81.1494 76.6038L32 46.0492L32.0332 31.4866L81.1826 62.0412Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130 31.4867L81.1826 62.0413L32.0332 31.4867L80.8672 0.949951L130 31.4867Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275 61.5367L226.183 92.0913L177.033 61.5367L225.867 31L275 61.5367Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M324 31.5367L323.967 46.0993L275.149 76.6539L275.182 62.0913L324 31.5367Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M324 31.5367L275.183 62.0913L226.033 31.5367L274.867 1L324 31.5367Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.9999 100.537L43.9667 115.099L-4.85071 145.654L-4.81751 131.091L43.9999 100.537Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44 100.537L-4.81743 131.091L-53.9668 100.537L-5.13281 70L44 100.537Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M276 122.667L275.967 137.23L227.149 167.785L227.182 153.222L276 122.667Z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M227.183 153.222L227.149 167.785L178 137.23L178.033 122.667L227.183 153.222Z",
    fill: "#F0F0F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276 122.667L227.183 153.222L178.033 122.667L226.867 92.1307L276 122.667Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M179.183 122.96L179.149 137.523L130 106.968L130.033 92.4059L179.183 122.96Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M228 92.406L179.183 122.961L130.033 92.406L178.867 61.8693L228 92.406Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M323 92.4059L322.967 106.968L274.149 137.523L274.182 122.96L323 92.4059Z",
    fill: "#F0F0F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M323 92.406L274.183 122.961L225.033 92.406L273.867 61.8693L323 92.406Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M398.183 139.172L398.149 153.735L349 123.18L349.033 108.617L398.183 139.172Z",
    fill: "#F0F0F0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M447 108.618L398.183 139.172L349.033 108.618L397.867 78.0808L447 108.618Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M372 122.667L371.967 137.23L323.149 167.785L323.182 153.222L372 122.667Z",
    fill: "#F0F0F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M323.183 153.222L323.149 167.785L274 137.23L274.033 122.667L323.183 153.222Z",
    fill: "#F0F0F0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M372 122.667L323.183 153.222L274.033 122.667L322.867 92.1307L372 122.667Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M421 152.929L420.967 167.492L372.149 198.046L372.182 183.484L421 152.929Z",
    fill: "#F0F0F0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M372.183 183.484L372.149 198.046L323 167.492L323.033 152.929L372.183 183.484Z",
    fill: "#F0F0F0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M421 152.929L372.183 183.484L323.033 152.929L371.867 122.392L421 152.929Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M325 152.929L324.967 167.492L276.149 198.046L276.182 183.484L325 152.929Z",
    fill: "#F0F0F0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M276.183 183.484L276.149 198.046L227 167.492L227.033 152.929L276.183 183.484Z",
    fill: "#F0F0F0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M325 152.929L276.183 183.484L227.033 152.929L275.867 122.392L325 152.929Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M374 183.19L373.967 197.753L325.149 228.308L325.182 213.745L374 183.19Z",
    fill: "#F0F0F0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M325.183 213.745L325.149 228.308L276 197.753L276.033 183.19L325.183 213.745Z",
    fill: "#F0F0F0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M374 183.191L325.183 213.745L276.033 183.191L324.867 152.654L374 183.191Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M421.183 213.745L421.149 228.308L372 197.753L372.033 183.19L421.183 213.745Z",
    fill: "#F0F0F0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M470 183.191L421.183 213.745L372.033 183.191L420.867 152.654L470 183.191Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423 213.452L422.967 228.015L374.149 258.569L374.182 244.007L423 213.452Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M374.183 244.007L374.149 258.569L325 228.015L325.033 213.452L374.183 244.007Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 213.452L374.183 244.007L325.033 213.452L373.867 182.915L423 213.452Z",
    fill: "white"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M180 122.667L179.967 137.23L131.149 167.785L131.182 153.222L180 122.667Z",
    fill: "#F0F0F0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M131.183 153.222L131.149 167.785L82 137.23L82.0332 122.667L131.183 153.222Z",
    fill: "#F0F0F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M180 122.667L131.183 153.222L82.0332 122.667L130.867 92.1307L180 122.667Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M228 152.929L227.967 167.492L179.149 198.046L179.182 183.484L228 152.929Z",
    fill: "#F0F0F0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M179.183 183.484L179.149 198.046L130 167.492L130.033 152.929L179.183 183.484Z",
    fill: "#F0F0F0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M228 152.929L179.183 183.484L130.033 152.929L178.867 122.392L228 152.929Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M179 183.19L178.967 197.753L130.149 228.308L130.182 213.745L179 183.19Z",
    fill: "#F0F0F0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130.183 213.745L130.149 228.308L81 197.753L81.0332 183.19L130.183 213.745Z",
    fill: "#F0F0F0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M179 183.191L130.183 213.745L81.0332 183.191L129.867 152.654L179 183.191Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277 183.19L276.967 197.753L228.149 228.308L228.182 213.745L277 183.19Z",
    fill: "#F0F0F0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M228.183 213.745L228.149 228.308L179 197.753L179.033 183.19L228.183 213.745Z",
    fill: "#F0F0F0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M277 183.191L228.183 213.745L179.033 183.191L227.867 152.654L277 183.191Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M362 137.798L361.967 152.361L313.149 182.915L313.182 168.353L362 137.798Z",
    fill: "#F0F0F0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M313.183 168.353L313.149 182.915L264 152.361L264.033 137.798L313.183 168.353Z",
    fill: "#F0F0F0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M362 137.798L313.183 168.353L264.033 137.798L312.867 107.261L362 137.798Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.183 168.353L410.149 182.915L361 152.361L361.033 137.798L410.183 168.353Z",
    fill: "#F0F0F0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M459 137.798L410.183 168.353L361.033 137.798L409.867 107.261L459 137.798Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M82.1826 183.484L82.1494 198.046L33 167.492L33.0332 152.929L82.1826 183.484Z",
    fill: "#F0F0F0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M131 152.929L82.1826 183.484L33.0332 152.929L81.8672 122.392L131 152.929Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M35.1826 154.303L35.1494 168.865L-14 138.311L-13.9668 123.748L35.1826 154.303Z",
    fill: "#F0F0F0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M84 123.748L35.1826 154.303L-13.9668 123.748L34.8672 93.2115L84 123.748Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M44 157.537L-4.81743 188.091L-53.9668 157.537L-5.13281 127L44 157.537Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.1826 219.091L43.1494 233.654L-6 203.099L-5.9668 188.537L43.1826 219.091Z",
    fill: "#F0F0F0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M92 188.537L43.1826 219.091L-5.9668 188.537L42.8672 158L92 188.537Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M132 93.4867L83.1826 124.041L34.0332 93.4867L82.8672 62.95L132 93.4867Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M141 218.856L140.967 233.418L92.1493 263.973L92.1825 249.41L141 218.856Z",
    fill: "#F0F0F0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M92.1826 249.41L92.1494 263.973L43 233.418L43.0332 218.856L92.1826 249.41Z",
    fill: "#F0F0F0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M141 218.856L92.1826 249.411L43.0332 218.856L91.8672 188.319L141 218.856Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M91.9999 249.537L91.9667 264.099L43.1493 294.654L43.1825 280.091L91.9999 249.537Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 249.537L43.1826 280.091L-5.9668 249.537L42.8672 219L92 249.537Z",
    fill: "white"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410 168.06L409.967 182.622L361.149 213.177L361.182 198.614L410 168.06Z",
    fill: "#F0F0F0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M361.183 198.614L361.149 213.177L312 182.622L312.033 168.06L361.183 198.614Z",
    fill: "#F0F0F0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M410 168.06L361.183 198.614L312.033 168.06L360.867 137.523L410 168.06Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M325.183 274.353L325.149 288.915L276 258.361L276.033 243.798L325.183 274.353Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374 243.798L325.183 274.353L276.033 243.798L324.867 213.262L374 243.798Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325 213.537L276.183 244.091L227.033 213.537L275.867 183L325 213.537Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.1 274.168L423.067 288.73L374.249 319.285L374.282 304.722L423.1 274.168Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M374.283 304.722L374.249 319.285L325.1 288.73L325.133 274.168L374.283 304.722Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.1 274.168L374.283 304.722L325.133 274.168L373.967 243.631L423.1 274.168Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M276 243.798L275.967 258.361L227.149 288.915L227.182 274.353L276 243.798Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M227.183 274.353L227.149 288.915L178 258.361L178.033 243.798L227.183 274.353Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 243.798L227.183 274.353L178.033 243.798L226.867 213.262L276 243.798Z",
    fill: "white"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M314 168.06L313.967 182.622L265.149 213.177L265.182 198.614L314 168.06Z",
    fill: "#F0F0F0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M265.183 198.614L265.149 213.177L216 182.622L216.033 168.06L265.183 198.614Z",
    fill: "#F0F0F0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M314 168.06L265.183 198.614L216.033 168.06L264.867 137.523L314 168.06Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M138 144.537L137.967 159.099L89.1493 189.654L89.1825 175.091L138 144.537Z",
    fill: "#F0F0F0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M89.1826 175.091L89.1494 189.654L40 159.099L40.0332 144.537L89.1826 175.091Z",
    fill: "#F0F0F0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M138 144.537L89.1826 175.091L40.0332 144.537L88.8672 114L138 144.537Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M236 122.537L235.967 137.099L187.149 167.654L187.182 153.091L236 122.537Z",
    fill: "#F0F0F0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M187.183 153.091L187.149 167.654L138 137.099L138.033 122.537L187.183 153.091Z",
    fill: "#F0F0F0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M236 122.537L187.183 153.091L138.033 122.537L186.867 92L236 122.537Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 218.537L-4.81743 249.091L-53.9668 218.537L-5.13281 188L44 218.537Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M42.9999 279.537L42.9667 294.099L-5.85071 324.654L-5.81751 310.091L42.9999 279.537Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 279.537L-5.81743 310.091L-54.9668 279.537L-6.13281 249L43 279.537Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.625769d1ce987d23680aba9662c35d65.svg";
export { ForwardRef as ReactComponent };